import React from "react";

const BannerPage = ({ title, subtitle, image }) => {
  return (
    <section className="relative w-full rounded-2xl overflow-hidden shadow-xl bg-idi-800 text-white min-h-[250px] flex items-center justify-center p-8 text-center mb-10 mt-6">
      {/* Background with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ 
          backgroundImage: image ? `url(${image})` : 'none',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-idi-950 via-idi-800/90 to-idi-950 opacity-95"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center max-w-4xl mx-auto gap-3">
        <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight uppercase">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg text-idi-200 max-w-2xl font-light">
            {subtitle}
          </p>
        )}
        <div className="w-20 h-1 bg-pesantrenGreen-500 rounded-full mt-2"></div>
      </div>
    </section>
  );
};

export default BannerPage;
